import { Injectable } from "@angular/core";
import { FileService } from "@core/services/file.service";
import { environment } from "environments/environment";
import { HttpService } from "../http.service";
import { QueryParams } from "services/models/odata/queryParams";
import { ServiceBase } from "../servicebase";
import { TrainingTypeModel } from "services/models/trainingType.model";
import { Observable } from "rxjs";
import { Response } from "services/models/response";
import { map } from "rxjs/operators";
import { ObjectMapper } from "json-object-mapper";
@Injectable({
  providedIn: 'root'
})
export class WorkforceplanTrainingService extends ServiceBase<TrainingTypeModel> {

  constructor(http: HttpService, private file: FileService) {
    super("WorkForcePlan", http, environment.apiUrl);
  }

  createEntity(input: any): TrainingTypeModel {
    return TrainingTypeModel.create(input);
  }

  listTrainings(): Observable<Response<TrainingTypeModel[]>> {
    const params = {
      select: ["name", "id", "enable", "creationDate", "validateHeadcountPlanning", "isAptitude"],
      orderBy: "name",
      orderByOrder: "asc",
    } as QueryParams;

    const query = this.createBuildQuery(params);
    return this.http
      .get(

        `${this.endpoint}/training-type/odata${query}`,
        undefined,
        this.baseUrl
      )
      .pipe(
        map((res) => {
          const response = new Response<TrainingTypeModel[]>();
          response.data = res.body.map(
            (pp) => this.createEntity(pp) as TrainingTypeModel
          );
          response.count = res.headers.get("x-count");
          return response;
        })
      );
  }

  saveTraining(id: string | undefined, obj: any) {
    console.log("Objeto antes da serialização:", obj);

    let _object = String(ObjectMapper.serialize(obj));
    let parsedObject = JSON.parse(_object);

    console.log("Objeto depois da serialização:", parsedObject);

    return id == undefined
      ? this.http.post(`${this.endpoint}/training-type`, parsedObject)
      : this.http.put(`${this.endpoint}/training-type`, parsedObject);
  }


}
